/**
 * Configurations state
 */
export default {
  list: [],
  object: {}
}